import floor01 from "@/assets/room-refresh/floor-01.jpg";
import floor02 from "@/assets/room-refresh/floor-02.jpg";
import floor03 from "@/assets/room-refresh/floor-03.jpg";
import floor04 from "@/assets/room-refresh/floor-04.jpg";
import floor05 from "@/assets/room-refresh/floor-05.jpg";
import floor06 from "@/assets/room-refresh/floor-06.jpg";
import floor07 from "@/assets/room-refresh/floor-07.jpg";
import floor08 from "@/assets/room-refresh/floor-08.jpg";
import floor09 from "@/assets/room-refresh/floor-09.jpg";
import floor10 from "@/assets/room-refresh/floor-10.jpg";
import wallpaper01 from "@/assets/room-refresh/wallpaper-01.jpg";
import wallpaper02 from "@/assets/room-refresh/wallpaper-02.jpg";
import wallpaper03 from "@/assets/room-refresh/wallpaper-03.jpg";
import wallpaper04 from "@/assets/room-refresh/wallpaper-04.jpg";
import wallpaper05 from "@/assets/room-refresh/wallpaper-05.jpg";
import wallpaper06 from "@/assets/room-refresh/wallpaper-06.jpg";
import wallpaper07 from "@/assets/room-refresh/wallpaper-07.jpg";
import wallpaper08 from "@/assets/room-refresh/wallpaper-08.jpg";
import wallpaper09 from "@/assets/room-refresh/wallpaper-09.jpg";
import wallpaper10 from "@/assets/room-refresh/wallpaper-10.jpg";

export interface RoomRefreshOptions {
  wallColor: string | null;
  floorStyle: string | null;
  wallpaper: string | null;
}

export const EMPTY_ROOM_REFRESH_OPTIONS: RoomRefreshOptions = {
  wallColor: null,
  floorStyle: null,
  wallpaper: null,
};

export const WALL_COLORS = [
  { name: "Warm White", swatchClass: "rr-wall-warm-white" },
  { name: "Cream", swatchClass: "rr-wall-cream" },
  { name: "Beige", swatchClass: "rr-wall-beige" },
  { name: "Soft Grey", swatchClass: "rr-wall-soft-grey" },
  { name: "Sage Green", swatchClass: "rr-wall-sage-green" },
  { name: "Olive", swatchClass: "rr-wall-olive" },
  { name: "Dusty Blue", swatchClass: "rr-wall-dusty-blue" },
  { name: "Terracotta", swatchClass: "rr-wall-terracotta" },
  { name: "Blush", swatchClass: "rr-wall-blush" },
  { name: "Charcoal", swatchClass: "rr-wall-charcoal" },
] as const;

export const FLOOR_STYLES = [
  { name: "White Marble", image: floor01 },
  { name: "Beige Marble", image: floor02 },
  { name: "Grey Marble", image: floor03 },
  { name: "Light Wood", image: floor04 },
  { name: "Dark Wood", image: floor05 },
  { name: "Terrazzo", image: floor06 },
  { name: "White Tile", image: floor07 },
  { name: "Stone", image: floor08 },
  { name: "Concrete", image: floor09 },
  { name: "Patterned Tile", image: floor10 },
] as const;

export const WALLPAPERS = [
  { name: "Minimal Beige", image: wallpaper01 },
  { name: "Soft Floral", image: wallpaper02 },
  { name: "Botanical", image: wallpaper03 },
  { name: "Textured White", image: wallpaper04 },
  { name: "Abstract", image: wallpaper05 },
  { name: "Geometric", image: wallpaper06 },
  { name: "Warm Linen", image: wallpaper07 },
  { name: "Marble", image: wallpaper08 },
  { name: "Subtle Stripes", image: wallpaper09 },
  { name: "Tropical", image: wallpaper10 },
] as const;

export const ROOM_REFRESH_SUGGESTIONS = [
  "Make it warmer and cozier",
  "Add more greenery",
  "Give it a luxury hotel feel",
  "Make it calm and relaxing",
  "Add more natural materials",
  "Improve the lighting",
  "Add a beautiful gallery wall",
  "Give it a modern makeover",
] as const;